window.addEventListener('DOMContentLoaded', function() {
$(document).ready(function() {
 $(document).on('click', '.jtpl-shapepopup', function(event) {
$(".jtpl-gemtooltip-Rhodium-popup").hide();
   $(".jtpl-gemtooltip-setting-popup").hide();
 });
    /****gemstone image tooltip content js ****/
    $(".tooltip_image").click(function() {
        var dataId = $(this).attr("data-attr");
        $('.jtpltooltip-content').hide();
        $("." + dataId).show();
    });

    $("#jtpl_eh_image").click(function() {
        var dataIdeh = $(this).attr("data-attr");
        $('#jtpl_eh_content').hide();
        $("." + dataIdeh).show();
    });

    $("#jtpl_qual_image").click(function() {
        var dataIds = $(this).attr("data-attr");
        $('#jtpl_qual_content').hide();
        $("." + dataIds).show();
    });

    $("#jtpl_size_image").click(function() {
        var dataIdsize = $(this).attr("data-attr");
        $('#jtpl_size_content').hide();
        $("." + dataIdsize).show();
    });


    /****shop the look button js ****/
    $(".shop-the-image-button button.shop-the-image-button__button").hover(
        function() {
            $(this).addClass("Shop_img_btn_hover");
        },
        function() {
            $(this).removeClass("Shop_img_btn_hover");
        }
    );

    $("div#shop_the_image_jtpl_banner1").click(function() {
        $(".contentFoto.jtpl_collection_prd_pop_up").addClass("show_pop_shop_look_jtpl1");
    });

    $('span.Shop_lk_pop_close svg').click(function() {
        $('.contentFoto.jtpl_collection_prd_pop_up').removeClass('show_pop_shop_look_jtpl1');
    });

    $("div#shop_the_image_jtpl_banner2").click(function() {
        $(".contentFoto.jtpl_collection_prd_pop_up").addClass("show_pop_shop_look_jtpl2");
    });
    $('span.Shop_lk_pop_close svg').click(function() {
        $('.contentFoto.jtpl_collection_prd_pop_up').removeClass('show_pop_shop_look_jtpl2');
    });


    $("div#shop_the_image_jtpl_banner3").click(function() {
        $(".contentFoto.jtpl_collection_prd_pop_up").addClass("show_pop_shop_look_jtpl3");
    });
    $('span.Shop_lk_pop_close svg').click(function() {
        $('.contentFoto.jtpl_collection_prd_pop_up').removeClass('show_pop_shop_look_jtpl3');
    });


    $(".shop-the-image-button").click(function() {
        $("body").addClass('jtpl-col-prod');
    });
    $('span.Shop_lk_pop_close svg').click(function() {
        $("body").removeClass('jtpl-col-prod');
    });



    /*** gemstone-color-tooltip-popup ****/

    $(".jtpl-gemtooltip-color").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $(".jtpl-gem-color-popup").show();

        var positionsStepped30 = document.getElementById('modal_cut_slider-gemcolor');
        var colorgemim = document.getElementById('colorgem_active_img').getAttribute('value');
        var colorgemim1 = document.getElementById(colorgemim).getAttribute('value');
        var colorgemit = document.getElementById('colorgem_active_text').getAttribute('value');
        var colorgemit1 = document.getElementById(colorgemit).getAttribute('value');
        var range_start_gemcolor1 = document.getElementById('colorgem_active_slider').getAttribute('value');

        var values = positionsStepped30.noUiSlider.get();
        var handle = range_start_gemcolor1;
        if (range_start_gemcolor1 == "0") {
            $(".noUi-origin").css("transform", "translate(-100%, 0px)");
        } else if (range_start_gemcolor1 == "100") {
            $(".noUi-origin").css("transform", "translate(-67%, 0px)");
        } else if (range_start_gemcolor1 == "200") {
            $(".noUi-origin").css("transform", "translate(-34%, 0px)");
        } else if (range_start_gemcolor1 == "300") {
            $(".noUi-origin").css("transform", "translate(-0%, 0px)");
        }
        if (range_start_gemcolor1 == 0) {

            $(".tooltip-arrow-1").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");

        }

        if (range_start_gemcolor1 == 100) {

            $(".tooltip-arrow-2").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");


        }
        if (range_start_gemcolor1 == 200) {

            $(".tooltip-arrow-3").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
        }


        if (range_start_gemcolor1 == 300) {

            $(".tooltip-arrow-4").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
        }
        $('.tooltip-inner-newcut p').text(colorgemit1);
    });
    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $(".jtpl-gem-color-popup").hide();
    });
    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-gem-color-popup').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });


    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-accent-qualitygem-popup').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });




    $(".jtpl-gemtooltip-size").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $(".jtpl-gem-size-popup-click").show();
        var positionsStepped28 = document.getElementById('modal_cut_slider-gemsize');
        var sizegemim = document.getElementById('sizegem_active_img').getAttribute('value');
        var sizegemim1 = document.getElementById(sizegemim).getAttribute('value');
        var sizegemit = document.getElementById('sizegem_active_text').getAttribute('value');
        var sizegemit1 = document.getElementById(sizegemit).getAttribute('value');
        var range_size_start_gem = 100;

        var values = positionsStepped28.noUiSlider.get();
        var handle = range_size_start_gem;
        $(".noUi-origin").css("transform", "translate(-75%, 0px)");
        $(".tooltip-arrow-6").addClass("hidden");
        $(".tooltip-arrow-1").removeClass("hidden");
        $(".tooltip-arrow-2").addClass("hidden");
        $(".tooltip-arrow-3").addClass("hidden");
        $(".tooltip-arrow-4").addClass("hidden");
        $(".tooltip-arrow-5").addClass("hidden");
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $(".jtpl-gem-size-popup-click").hide();
    });
    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-gem-size-popup-click').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });




    $(".jtpl-gemtooltip-quality, .jtplgemtooltipquality").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $(".jtpl-gem-quality-popup-click").show();
        var positionsStepped40 = document.getElementById('modal_cut_slider-gemquality');
        var qalitygemim = document.getElementById('qalitygem_active_img').getAttribute('value');
        var qalitygemim1 = document.getElementById(qalitygemim).getAttribute('value');
        var qalitygemit = document.getElementById('qalitygem_active_text').getAttribute('value');
        var qalitygemit1 = document.getElementById(qalitygemit).getAttribute('value');
        var range_start_gemquality = document.getElementById('qalitygem_active_slider').getAttribute('value');

        var values = positionsStepped40.noUiSlider.get();
        var handle = range_start_gemquality;
      
        if (range_start_gemquality == "200") {
            $(".noUi-origin").css("transform", "translate(-34%, 0px)");
        } else if (range_start_gemquality == "300") {
            $(".noUi-origin").css("transform", "translate(-0%, 0px)");
        }
      
        if (range_start_gemquality == 200) {

            $(".qltooltip-arrow-3").removeClass("hidden");
            $(".qltooltip-arrow-2").addClass("hidden");
            $(".qltooltip-arrow-1").addClass("hidden");
            $(".qltooltip-arrow-4").addClass("hidden");
            $(".qltooltip-arrow-5").addClass("hidden");


        }

        if (range_start_gemquality == 300) {

            $(".qltooltip-arrow-4").removeClass("hidden");
            $(".qltooltip-arrow-2").addClass("hidden");
            $(".qltooltip-arrow-3").addClass("hidden");
            $(".qltooltip-arrow-1").addClass("hidden");
            $(".qltooltip-arrow-5").addClass("hidden");


        }


        $('.tooltip-inner-newquality p').text(qalitygemit1);

    });
    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $(".jtpl-gem-quality-popup-click").hide();
    });
    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-gem-quality-popup-click').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });



    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-accent-qualitygem-popup').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });


    $(".jtpl-gemtooltip-size").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $(".jtpl-gem-size-popup-click").show();
        var positionsStepped28 = document.getElementById('modal_cut_slider-gemsize');
        var sizegemim = document.getElementById('sizegem_active_img').getAttribute('value');
        var sizegemim1 = document.getElementById(sizegemim).getAttribute('value');
        var sizegemit = document.getElementById('sizegem_active_text').getAttribute('value');
        var sizegemit1 = document.getElementById(sizegemit).getAttribute('value');
        var range_size_start_gem = 0;

        var values = positionsStepped28.noUiSlider.get();
        var handle = range_size_start_gem;
        $(".noUi-origin").css("transform", "translate(-100%, 0px)");

        $(".tooltip-arrow-1").removeClass("hidden");
        $(".tooltip-arrow-2").addClass("hidden");
        $('.tooltip-inner-newsize p').text(sizegemit1);




    });
    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $(".jtpl-gem-size-popup-click").hide();
    });



    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-gem-size-popup-click').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });



    $(".jtpl-gemtooltip-cut, .jtplgemtooltipcut").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $(".jtpl-gem-cut-popup").show();




        var positionsStepped60 = document.getElementById('modal_cut_slider-gemcut');

        var cutgemit = document.getElementById('cutgem_active_text').getAttribute('value');
        var cutgemit1 = document.getElementById(cutgemit).getAttribute('value');
        var range_start_gemcut = document.getElementById('cutgem_active_slider').getAttribute('value');

        var values = positionsStepped60.noUiSlider.get();
        var handle = range_start_gemcut;
        if (range_start_gemcut == "0") {
            $(".noUi-origin").css("transform", "translate(-100%, 0px)");
        } else if (range_start_gemcut == "100") {
            $(".noUi-origin").css("transform", "translate(-75%, 0px)");
        } else if (range_start_gemcut == "200") {
            $(".noUi-origin").css("transform", "translate(-50%, 0px)");
        } else if (range_start_gemcut == "300") {
            $(".noUi-origin").css("transform", "translate(-25%, 0px)");
        } else if (range_start_gemcut == "400") {
            $(".noUi-origin").css("transform", "translate(-0%, 0px)");
        }
        if (range_start_gemcut == 0) {

            $(".cltooltip-arrow-1").removeClass("hidden");
            $(".cltooltip-arrow-2").addClass("hidden");
            $(".cltooltip-arrow-3").addClass("hidden");
            $(".cltooltip-arrow-4").addClass("hidden");

        }

        if (range_start_gemcut == 100) {

            $(".cltooltip-arrow-2").removeClass("hidden");
            $(".cltooltip-arrow-1").addClass("hidden");
            $(".cltooltip-arrow-3").addClass("hidden");
            $(".cltooltip-arrow-4").addClass("hidden");


        }
        if (range_start_gemcut == 200) {

            $(".cltooltip-arrow-3").removeClass("hidden");
            $(".cltooltip-arrow-2").addClass("hidden");
            $(".cltooltip-arrow-1").addClass("hidden");
            $(".cltooltip-arrow-4").addClass("hidden");
            $(".cltooltip-arrow-5").addClass("hidden");


        }

        if (range_start_gemcut == 300) {
            $(".cltooltip-arrow-4").removeClass("hidden");
            $(".cltooltip-arrow-2").addClass("hidden");
            $(".cltooltip-arrow-3").addClass("hidden");
            $(".cltooltip-arrow-1").addClass("hidden");
            $(".cltooltip-arrow-5").addClass("hidden");
        }

        if (range_start_gemcut == 400) {
            $(".cltooltip-arrow-5").removeClass("hidden");
            $(".cltooltip-arrow-2").addClass("hidden");
            $(".cltooltip-arrow-3").addClass("hidden");
            $(".cltooltip-arrow-1").addClass("hidden");
            $(".cltooltip-arrow-4").addClass("hidden");
        }


        $('.tooltip-inner-newcut p').text(cutgemit1);




    });
    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $(".jtpl-gem-cut-popup").hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-gem-cut-popup').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });


    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-gem-quality-popup-click').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });







    $(".jtpl-gemtooltip-enhancment").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $(".jtpl-gem-enhancement-popup").show();

        // var positionsStepped50 = document.getElementById('modal_cut_slider-gemehnance');
        // var ehgemim = document.getElementById('ehgem_active_img').getAttribute('value');
        // var ehgemim1 = document.getElementById(ehgemim).getAttribute('value');
        // var ehgemit = document.getElementById('ehgem_active_text').getAttribute('value');
        // var ehgemit1 = document.getElementById(ehgemit).getAttribute('value');
        // var range_start_gemenhan = document.getElementById('ehgem_active_slider').getAttribute('value');

        // var values = positionsStepped50.noUiSlider.get();
        // var handle = range_start_gemenhan;
        // if (range_start_gemenhan == "0") {
        //     $(".noUi-origin").css("transform", "translate(-100%, 0px)");
        // } else if (range_start_gemenhan == "100") {
        //     $(".noUi-origin").css("transform", "translate(-0%, 0px)");
        // }
        // if (range_start_gemenhan == 0) {

        //     $(".tooltip-arrow-1").removeClass("hidden");
        //     $(".tooltip-arrow-2").addClass("hidden");

        // }

        // if (range_start_gemenhan == 100) {
        //     $(".tooltip-arrow-2").removeClass("hidden");
        //     $(".tooltip-arrow-1").addClass("hidden");
        // }

        // $('.tooltip-inner-neweh p').text(qalitygemit1);


    });


    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $(".jtpl-gem-enhancement-popup").hide();
    });
    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-gem-enhancement-popup').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });
 
  
     $(".jtpl-gemtooltip-metal").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-gemtooltip-metal-popup').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-gemtooltip-metal-popup').hide();
    });

  
 $(".gemstone_detail_rhodium_tool").click(function() {
       $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-gemtooltip-Rhodium-popup').show();
    });


   $(".Rhodium-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-gemtooltip-Rhodium-popup').hide();
    });
  $(".gemstone_detail_setting_tool").click(function() {
       $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-gemtooltip-setting-popup').show();
    });


   $(".Rhodium-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-gemtooltip-setting-popup').hide();
    });



  
    $(".jtpl-gemtooltip-origin").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-gemtooltip-origin-popup').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-gemtooltip-origin-popup').hide();
    });
  

    $(".jtpl-gemtooltip-dimension").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-dimensionnt-popup').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-dimensionnt-popup').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-dimensionnt-popup').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });



    $(".jtpl-gemtooltip-rhodium").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-necklase-rhodium').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-necklase-rhodium').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-necklase-rhodium').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });


  
 $(".jtpl-culet-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-culet-dyor').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-culet-dyor').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-culet-dyor').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });

  
   $(".jtpl-table-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-table-dyor').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-table-dyor').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-table-dyor').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });



     $(".jtpl-depth-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-depth-dyor').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-depth-dyor').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-depth-dyor').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });


   $(".jtpl-symmetry-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-symmetry-dyor').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-symmetry-dyor').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-symmetry-dyor').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });



  $(".jtpl-polish-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-polish-dyor').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-polish-dyor').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-polish-dyor').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });

   $(".jtpl-report-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-report-dyor').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-report-dyor').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-report-dyor').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });



    $(".jtpl-fluorescenc-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-fluorescenc-dyor').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-fluorescenc-dyor').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-fluorescenc-dyor').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });


  
 $(".jtpl-ratio-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-ratio-dyor').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-ratio-dyor').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-ratio-dyor').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });




   $(".jtpl-origin-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-origin-dyor').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-origin-dyor').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-origin-dyor').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });

  
  
  
 $(".jtpl-measurement-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-measurement-dyor').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-measurement-dyor').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-measurement-dyor').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });


  
$(".jtpl-earring-backing, .jtplbackingtype").click(function(){

$(".jtpl_overlay").addClass('jtpl-shapepopup');
$("body").addClass('jtpl-shapepopup1');
$('.jtpl-earring-backing-popup').show();
var positionsStepped28 = document.getElementById('modal_type_slider-gembacking');
var backinggemim = document.getElementById('backinggem_active_img').getAttribute('value');
var backinggemim1 = document.getElementById(backinggemim).getAttribute('value');
var backinggemit = document.getElementById('backinggem_active_text').getAttribute('value');
var backinggemit1 = document.getElementById(backinggemit).getAttribute('value');     
var range_backing_start_gem = 0 ; 
  
var values = positionsStepped28.noUiSlider.get();  
var handle = range_backing_start_gem;
if(range_backing_start_gem == 0){
 $(".noUi-origin").css("transform", "translate(-100%, 0px)");   
   $(".tooltip-arrow-1").removeClass("hidden");
   $(".tooltip-arrow-2").addClass("hidden");
   $(".tooltip-arrow-3").addClass("hidden");
   $(".tooltip-arrow-4").addClass("hidden");
   $(".tooltip-arrow-5").addClass("hidden");
   $(".tooltip-arrow-6").addClass("hidden");
 
}
  
if(range_backing_start_gem == 100){
  $(".noUi-origin").css("transform", "translate(-80%, 0px)");   
    $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");
    $(".tooltip-arrow-3").addClass("hidden");
    $(".tooltip-arrow-4").addClass("hidden");
    $(".tooltip-arrow-5").addClass("hidden");
    $(".tooltip-arrow-6").addClass("hidden");
  
}
  
if(range_backing_start_gem == 200){
 $(".noUi-origin").css("transform", "translate(-60%, 0px)");   
    $(".tooltip-arrow-3").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");
    $(".tooltip-arrow-4").addClass("hidden");
    $(".tooltip-arrow-5").addClass("hidden");
   $(".tooltip-arrow-6").addClass("hidden");
 
}
if(range_backing_start_gem == 300){
 $(".noUi-origin").css("transform", "translate(-40%, 0px)");   
    $(".tooltip-arrow-4").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");
    $(".tooltip-arrow-3").addClass("hidden");
    $(".tooltip-arrow-5").addClass("hidden");
   $(".tooltip-arrow-6").addClass("hidden");
 
}
if(range_backing_start_gem == 400){
$(".noUi-origin").css("transform", "translate(-20%, 0px)");   
  $(".tooltip-arrow-5").removeClass("hidden");
  $(".tooltip-arrow-1").addClass("hidden");
  $(".tooltip-arrow-2").addClass("hidden");
  $(".tooltip-arrow-3").addClass("hidden");
  $(".tooltip-arrow-4").addClass("hidden");
  $(".tooltip-arrow-6").addClass("hidden");
  
}
if(range_backing_start_gem == 500){
$(".noUi-origin").css("transform", "translate(-0%, 0px)");   
  $(".tooltip-arrow-6").removeClass("hidden");
  $(".tooltip-arrow-1").addClass("hidden");
  $(".tooltip-arrow-2").addClass("hidden");
  $(".tooltip-arrow-3").addClass("hidden");
  $(".tooltip-arrow-4").addClass("hidden");
  $(".tooltip-arrow-5").addClass("hidden");

}
 $('.tooltip-inner-newbacking p').text(backinggemit1);
$(".img-slider-necklace-backing").attr("src",backinggemim1);
  
});
  
   $(".jtpl-close").click(function(){
      $(".jtpl_overlay").removeClass('jtpl-shapepopup');
      $("body").removeClass('jtpl-shapepopup1');
   $('.jtpl-earring-backing-popup').hide();
   });

$(document).on('click', '.jtpl-shapepopup', function(event) {
 $('.jtpl-earring-backing-popup').hide();
 $(".jtpl_overlay").removeClass('jtpl-shapepopup');
   $("body").removeClass('jtpl-shapepopup1');
});



  

    $(".jtpl-gemtooltip-certificate ").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-gem-certificate-popup').show();

        var positionsSteppedgemcerti = document.getElementById('modal_cut_slider-gemcerti');

        var certiit = document.getElementById('certigem_active_text').getAttribute('value');
        var certiit1 = document.getElementById(certiit).getAttribute('value');
        var range_start_gemencerti = document.getElementById('certigem_active_slider').getAttribute('value');

        var values = positionsSteppedgemcerti.noUiSlider.get();
        var handle = range_start_gemencerti;
        if (range_start_gemencerti == 0) {
            $(".noUi-origin").css("transform", "translate(-100%, 0px)");
            $(".tooltip-arrow-1").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
        }

        if (range_start_gemencerti == 100) {
            $(".noUi-origin").css("transform", "translate(-67%, 0px)");
            $(".tooltip-arrow-2").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
        }

        if (range_start_gemencerti == 200) {
            $(".noUi-origin").css("transform", "translate(-34%, 0px)");
            $(".tooltip-arrow-2").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");

        }
        if (range_start_gemencerti == 300) {
            $(".noUi-origin").css("transform", "translate(-0%, 0px)");
            $(".tooltip-arrow-2").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");

        }

        $('.tooltip-inner-newcerti p').text(certiit1);

    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-gem-certificate-popup').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-gem-certificate-popup').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });




    $(".jtpl-necklace-popup ").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-necklace-tooltip').show();


    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-necklace-tooltip').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-necklace-tooltip').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });

    /*** accentstone-tooltip-popup ****/
    $(".jtpl-necklace-type").click(function() {

        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-necklace-type-popup').show();
        var positionsStepped28 = document.getElementById('modal_type_slider-gemtype');
        var typegemim = document.getElementById('typegem_active_img').getAttribute('value');
        var typegemim1 = document.getElementById(typegemim).getAttribute('value');
        var typegemit = document.getElementById('typegem_active_text').getAttribute('value');
        var typegemit1 = document.getElementById(typegemit).getAttribute('value');
        var range_type_start_gem = 0;

        var values = positionsStepped28.noUiSlider.get();
        var handle = range_type_start_gem;
        if (range_type_start_gem == 0) {
            $(".noUi-origin").css("transform", "translate(-100%, 0px)");
            $(".tooltip-arrow-1").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");

        }

        if (range_type_start_gem == 100) {
            $(".noUi-origin").css("transform", "translate(-80%, 0px)");
            $(".tooltip-arrow-2").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");

        }

        if (range_type_start_gem == 200) {
            $(".noUi-origin").css("transform", "translate(-60%, 0px)");
            $(".tooltip-arrow-3").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");

        }
        if (range_type_start_gem == 300) {
            $(".noUi-origin").css("transform", "translate(-40%, 0px)");
            $(".tooltip-arrow-4").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");

        }
        if (range_type_start_gem == 400) {
            $(".noUi-origin").css("transform", "translate(-20%, 0px)");
            $(".tooltip-arrow-5").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");

        }
        if (range_type_start_gem == 500) {
            $(".noUi-origin").css("transform", "translate(-0%, 0px)");
            $(".tooltip-arrow-6").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");

        }
        $('.tooltip-inner-newtype p').text(typegemit1);
        $(".img-slider-necklace").attr("src", typegemim1);

    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-necklace-type-popup').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-necklace-type-popup').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });




    $(".jtpl-necklace-clasp").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-necklace-clasp-popup').show();
        var positionsStepped28 = document.getElementById('modal_type_slider-gemclasp');
        var claspgemim = document.getElementById('claspgem_active_img').getAttribute('value');
        var claspgemim1 = document.getElementById(claspgemim).getAttribute('value');
        var claspgemit = document.getElementById('claspgem_active_text').getAttribute('value');
        var claspgemit1 = document.getElementById(claspgemit).getAttribute('value');
        var range_clasp_start_gem = 0;

        var values = positionsStepped28.noUiSlider.get();
        var handle = range_clasp_start_gem;
        if (range_clasp_start_gem == 0) {
            $(".noUi-origin").css("transform", "translate(-100%, 0px)");
            $(".tooltip-arrow-1").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");

        }

        if (range_clasp_start_gem == 100) {
            $(".noUi-origin").css("transform", "translate(-80%, 0px)");
            $(".tooltip-arrow-2").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");

        }

        if (range_clasp_start_gem == 200) {
            $(".noUi-origin").css("transform", "translate(-60%, 0px)");
            $(".tooltip-arrow-3").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");

        }
        if (range_clasp_start_gem == 300) {
            $(".noUi-origin").css("transform", "translate(-40%, 0px)");
            $(".tooltip-arrow-4").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");

        }
        if (range_clasp_start_gem == 400) {
            $(".noUi-origin").css("transform", "translate(-20%, 0px)");
            $(".tooltip-arrow-5").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");

        }
        if (range_clasp_start_gem == 500) {
            $(".noUi-origin").css("transform", "translate(-0%, 0px)");
            $(".tooltip-arrow-6").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");

        }
        $('.tooltip-inner-newclasp p').text(claspgemit1);
        $(".img-slider-necklace-clasp").attr("src", claspgemim1);


    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-necklace-clasp-popup').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-necklace-clasp-popup').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });




    $(".jtpl-accent-size-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-accent-size-popup').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-accent-size-popup').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-accent-size-popup').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });


    $(".jtpl-shape-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-accentstone-shape-popup').show();
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-accentstone-shape-popup').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $('.jtpl-accentstone-shape-popup').hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });

    $(".jtpl-accent-color-tooltip").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-accent-color-popup-click').show();

        
   var colorddata = document.querySelector("#detail-color-value");
     
  var colordata_accent = $(this).parents('.jtpl-gemstone-title').find('.detail-color-value-accent');
     
      if(colorddata !== null) {
      colorddata = colorddata.getAttribute('value');
      } else if(colordata_accent != null){
      colorddata = colordata_accent.attr('value');  
      }else{
      colorddata = 0; 
      }
    
var positionsStepped25 = document.getElementById('modal_color_slider');
if(colorddata == 0){

var colorim = document.getElementById('color_active_img').getAttribute('value');
var colorim1 = document.getElementById(colorim).getAttribute('value');
var colorit = document.getElementById('color_active_text').getAttribute('value');
var colorit1 = document.getElementById(colorit).getAttribute('value');   
var range_start_color = document.getElementById('color_active_slider').getAttribute('value'); 
  
} else if(colorddata == 'J' ){
var colorim1 = document.getElementById('new1').getAttribute('value');
var colorit1 = document.getElementById('newtext1').getAttribute('value');     
var range_start_color = 0;
} else if(colorddata == 'I'){

var colorim1 = document.getElementById('new2').getAttribute('value');
var colorit1 = document.getElementById('newtext2').getAttribute('value');     
var range_start_color = 100;  
} else if(colorddata == 'H'){
var colorim1 = document.getElementById('new3').getAttribute('value');
var colorit1 = document.getElementById('newtext3').getAttribute('value');     
var range_start_color = 200; 
} else if(colorddata == 'G'){
var colorim1 = document.getElementById('new4').getAttribute('value');
var colorit1 = document.getElementById('newtext4').getAttribute('value');     
var range_start_color = 300; 
} else if(colorddata == 'F'){
var colorim1 = document.getElementById('new5').getAttribute('value');
var colorit1 = document.getElementById('newtext5').getAttribute('value');     
var range_start_color = 400; 
} else if(colorddata == 'E'){
var colorim1 = document.getElementById('new6').getAttribute('value');
var colorit1 = document.getElementById('newtext6').getAttribute('value');     
var range_start_color = 500; 
}  else if(colorddata == 'D'){
var colorim1 = document.getElementById('new7').getAttribute('value');
var colorit1 = document.getElementById('newtext7').getAttribute('value');     
var range_start_color = 600; 
} else{
var colorim1 = document.getElementById('new7').getAttribute('value');
var colorit1 = document.getElementById('newtext7').getAttribute('value');   
var range_start_color = 600;  
}


        var values = positionsStepped25.noUiSlider.get();
        var handle = range_start_color;
        if (range_start_color == "0") {
           $(".jtpl-color-slide .noUi-origin").css("transform", "translate(-100%, 0px)");
        } else if (range_start_color == "100") {
            $(".jtpl-color-slide .noUi-origin").css("transform", "translate(-83.18%, 0px)");
        } else if (range_start_color == "200") {
            $(".jtpl-color-slide .noUi-origin").css("transform", "translate(-66.58%, 0px)");
        } else if (range_start_color == "300") {
           $(".jtpl-color-slide .noUi-origin").css("transform", "translate(-49.9%, 0px)");
        } else if (range_start_color == "400") {
            $(".jtpl-color-slide .noUi-origin").css("transform", "translate(-33.42%, 0px)");
        } else if (range_start_color == "500") {
            $(".jtpl-color-slide .noUi-origin").css("transform", "translate(-16.6%, 0px)");
        } else if (range_start_color == "600") {
            $(".jtpl-color-slide .noUi-origin").css("transform", "translate(-0%, 0px)");
        }

        if (range_start_color == 0) {


            $(".tooltip-arrow-1").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");
            $(".tooltip-arrow-7").addClass("hidden");

        }

        if (range_start_color == 100) {


            $(".tooltip-arrow-2").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");
            $(".tooltip-arrow-7").addClass("hidden");

        }

        if (range_start_color == 200) {

            $(".tooltip-arrow-3").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");
            $(".tooltip-arrow-7").addClass("hidden");

        }

        if (range_start_color == 300) {

            $(".tooltip-arrow-4").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");
            $(".tooltip-arrow-7").addClass("hidden");

        }

        if (range_start_color == 400) {

            $(".tooltip-arrow-5").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");
            $(".tooltip-arrow-7").addClass("hidden");

        }

        if (range_start_color == 500) {

            $(".tooltip-arrow-6").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden1");
            $(".tooltip-arrow-3").addClass("hidden1");
            $(".tooltip-arrow-4").addClass("hidden1");
            $(".tooltip-arrow-5").addClass("hidden1");
            $(".tooltip-arrow-1").addClass("hidden1");
            $(".tooltip-arrow-7").addClass("hidden1");

        }

        if (range_start_color == 600) {

            $(".tooltip-arrow-7").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");
            $(".tooltip-arrow-3").addClass("hidden");
            $(".tooltip-arrow-4").addClass("hidden");
            $(".tooltip-arrow-5").addClass("hidden");
            $(".tooltip-arrow-6").addClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");

        }

        $('.tooltip-inner p').text(colorit1);
        $(".img-slider-cut").attr("src", colorim1);


    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-accent-color-popup-click').hide();
    });

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $('.jtpl-accent-color-popup-click').hide();
        $("body").removeClass('jtpl-shapepopup1');
    });




    $(".jtpl-accent-treatment").click(function() {
      
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-accent-treatment-popup0').show();


        var positionsStepped640 = document.getElementById('modal_cut_slider-gemtreat33');

        var treatgemit44 = document.getElementById('treatgem_active_text').getAttribute('value');
        var treatgemit14 = document.getElementById(treatgemit44).getAttribute('value');
    
        var range_start_gemtreat44 = document.getElementById('treatgem_active_slider').getAttribute('value');

        var values = positionsStepped640.noUiSlider.get();
        var handle = range_start_gemtreat44;

        if (range_start_gemtreat44 == 0) {
            $(".noUi-origin").css("transform", "translate(-100%, 0px)");
            $(".tooltip-arrow-1").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");

        }

        if (range_start_gemtreat44 == 100) {
            $(".noUi-origin").css("transform", "translate(-0%, 0px)");
            $(".tooltip-arrow-2").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
        }
        $('.tooltip-inner-newtreat p').text(treatgemit1);
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-accent-treatment-popup0').hide();
    });


    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $(".jtpl-accent-treatment-popup0").hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });
 var treatgemtext1='',treatgemtext2='';
if(document.getElementById('treattext1')!= null){
 treatgemtext1 = document.getElementById('treattext1').getAttribute('value');
}
if(document.getElementById('treattext2') != null){
treatgemtext2 = document.getElementById('treattext2').getAttribute('value'); 
}
var positionsSteppedgemeh = document.getElementById('modal_cut_slider-gemtreat33');

$('#treatgemtextclick-1').click(function() {

 var values = positionsSteppedgemeh.noUiSlider.get();
  var handle = 0;
$(".noUi-origin").css("transform", "translate(-100%, 0px)");  
$('.tooltip-inner-newtreat p').text(treatgemtext1);
   $(".tooltip-arrow-1").removeClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");  
 
});

$('#treatgemtextclick-2').click(function() {
var values = positionsSteppedgemeh.noUiSlider.get();
var handle = 100;
$(".noUi-origin").css("transform", "translate(-0%, 0px)");   
$('.tooltip-inner-newtreat p').text(treatgemtext2);
   $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");

});
if(document.getElementById('ehgem_active_slider') != null){
var range_start_gemeh = document.getElementById('ehgem_active_slider').getAttribute('value'); 
    
noUiSlider.create(positionsSteppedgemeh, {
    start: range_start_gemeh,
    snap: true,
    connect: true,
   range: {
        'min': 0,
        'max': 100,
       
    }
});

positionsSteppedgemeh.noUiSlider.on('change', function (values, handle) { 
if(values[handle] == 0){
  $('.tooltip-inner-newtreat p').text(treatgemtext1);
    $(".tooltip-arrow-1").removeClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");

}
  
if(values[handle] == 100){
  $('.tooltip-inner-newtreat p').text(treatgemtext2);
    $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");

}

});
}
  

  
$(".jtpl-accent-treatment1").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-accent-treatment-popup1').show();


        var positionsStepped600 = document.getElementById('modal_cut_slider-gemtreat1');

        var treatgemit500 = document.getElementById('treatgem_active_text1').getAttribute('value');
        var treatgemit1500 = document.getElementById(treatgemit500).getAttribute('value');
        var range_start_gemtreat500 = document.getElementById('treatgem_active_slider1').getAttribute('value');

        var values = positionsStepped600.noUiSlider.get();
        var handle = range_start_gemtreat500;
     
        if (range_start_gemtreat500 == 0) {
            $(".noUi-origin").css("transform", "translate(-100%, 0px)");
            $(".tooltip-arrow-1").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");

        }

        if (range_start_gemtreat500 == 100) {
            $(".noUi-origin").css("transform", "translate(-0%, 0px)");
            $(".tooltip-arrow-2").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
        }
        $('.tooltip-inner-newtreat p').text(treatgemit1);
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-accent-treatment-popup1').hide();
    });


    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $(".jtpl-accent-treatment-popup1").hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });


 
 var treatgemtext1='',treatgemtext2='';
if(document.getElementById('treattext1')!= null){
 treatgemtext1 = document.getElementById('treattext1').getAttribute('value');
}
if(document.getElementById('treattext2') != null){
treatgemtext2 = document.getElementById('treattext2').getAttribute('value'); 
}
var positionsSteppedgemeh = document.getElementById('modal_cut_slider-gemtreat1');

$('#treatgemtextclick1-1').click(function() {

 var values = positionsSteppedgemeh.noUiSlider.get();
  var handle = 0;
$(".noUi-origin").css("transform", "translate(-100%, 0px)");  
$('.tooltip-inner-newtreat p').text(treatgemtext1);
   $(".tooltip-arrow-1").removeClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");  
 
});

$('#treatgemtextclick1-2').click(function() {
var values = positionsSteppedgemeh.noUiSlider.get();
var handle = 100;
$(".noUi-origin").css("transform", "translate(-0%, 0px)");   
$('.tooltip-inner-newtreat p').text(treatgemtext2);
   $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");

});
if(document.getElementById('ehgem_active_slider') != null){
var range_start_gemeh = document.getElementById('ehgem_active_slider').getAttribute('value'); 
    
noUiSlider.create(positionsSteppedgemeh, {
    start: range_start_gemeh,
    snap: true,
    connect: true,
   range: {
        'min': 0,
        'max': 100,
       
    }
});

positionsSteppedgemeh.noUiSlider.on('change', function (values, handle) { 
if(values[handle] == 0){
  $('.tooltip-inner-newtreat p').text(treatgemtext1);
    $(".tooltip-arrow-1").removeClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");

}
  
if(values[handle] == 100){
  $('.tooltip-inner-newtreat p').text(treatgemtext2);
    $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");

}

});
}
$('#accent_treat_close1').click(function() {

var positionsStepped560 = document.getElementById('modal_cut_slider-gemtreat1');

var treatgemit = document.getElementById('treatgem_active_text').getAttribute('value');
var treatgemit1 = document.getElementById(treatgemit).getAttribute('value');     
var range_start_gemtreat555= document.getElementById('treatgem_active_slider').getAttribute('value'); 
  
var values = positionsStepped560.noUiSlider.get();  
var handle = range_start_gemtreat;

if(range_start_gemtreat555 == 0){
 $(".noUi-origin").css("transform", "translate(-100%, 0px)");    
    $(".tooltip-arrow-1").removeClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");

}
  
if(range_start_gemtreat555 == 100){
  $(".noUi-origin").css("transform", "translate(-0%, 0px)"); 
   $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");
}

$('.tooltip-inner-newtreat p').text(treatgemit1);

  
});  



$(".jtpl-accent-treatment3").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-accent-treatment-popup3').show();


        var positionsStepped600 = document.getElementById('modal_cut_slider-gemtreat100');

        var treatgemit500 = document.getElementById('treatgem_active_text3').getAttribute('value');
        var treatgemit1500 = document.getElementById(treatgemit500).getAttribute('value');
        var range_start_gemtreat500 = document.getElementById('treatgem_active_slider3').getAttribute('value');

        var values = positionsStepped600.noUiSlider.get();
        var handle = range_start_gemtreat500;
     
        if (range_start_gemtreat500 == 0) {
            $(".noUi-origin").css("transform", "translate(-100%, 0px)");
            $(".tooltip-arrow-1").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");

        }

        if (range_start_gemtreat500 == 100) {
            $(".noUi-origin").css("transform", "translate(-0%, 0px)");
            $(".tooltip-arrow-2").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
        }
        $('.tooltip-inner-newtreat p').text(treatgemit1500);
    });

    $(".jtpl-close").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-accent-treatment-popup1').hide();
    });


    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $(".jtpl-accent-treatment-popup1").hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });


 
 
 var treatgemtext1='',treatgemtext2='';
if(document.getElementById('treattext1')!= null){
 treatgemtext1 = document.getElementById('treattext1').getAttribute('value');
}
if(document.getElementById('treattext2') != null){
treatgemtext2 = document.getElementById('treattext2').getAttribute('value'); 
}
var positionsSteppedgemeh = document.getElementById('modal_cut_slider-gemtreat100');

$('#treatgemtextclick3-1').click(function() {

 var values = positionsSteppedgemeh.noUiSlider.get();
  var handle = 0;
$(".noUi-origin").css("transform", "translate(-100%, 0px)");  
$('.tooltip-inner-newtreat p').text(treatgemtext1);
   $(".tooltip-arrow-1").removeClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");  
 
});

$('#treatgemtextclick3-2').click(function() {
var values = positionsSteppedgemeh.noUiSlider.get();
var handle = 100;
$(".noUi-origin").css("transform", "translate(-0%, 0px)");   
$('.tooltip-inner-newtreat p').text(treatgemtext2);
   $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");

});
if(document.getElementById('ehgem_active_slider') != null){
var range_start_gemeh = document.getElementById('ehgem_active_slider').getAttribute('value'); 
    
noUiSlider.create(positionsSteppedgemeh, {
    start: range_start_gemeh,
    snap: true,
    connect: true,
   range: {
        'min': 0,
        'max': 100,
       
    }
});

positionsSteppedgemeh.noUiSlider.on('change', function (values, handle) { 
if(values[handle] == 0){
  $('.tooltip-inner-newtreat p').text(treatgemtext1);
    $(".tooltip-arrow-1").removeClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");

}
  
if(values[handle] == 100){
  $('.tooltip-inner-newtreat p').text(treatgemtext2);
    $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");

}

});
}
$('#accent_treat_close3').click(function() {

var positionsStepped560 = document.getElementById('modal_cut_slider-gemtreat100');

var treatgemit = document.getElementById('treatgem_active_text').getAttribute('value');
var treatgemit1 = document.getElementById(treatgemit).getAttribute('value');     
var range_start_gemtreat555= document.getElementById('treatgem_active_slider').getAttribute('value'); 
  
var values = positionsStepped560.noUiSlider.get();  
var handle = range_start_gemtreat555;

if(range_start_gemtreat555 == 0){
 $(".noUi-origin").css("transform", "translate(-100%, 0px)");    
    $(".tooltip-arrow-1").removeClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");

}
  
if(range_start_gemtreat555 == 100){
  $(".noUi-origin").css("transform", "translate(-0%, 0px)"); 
   $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");
}

$('.tooltip-inner-newtreat p').text(treatgemit1);

  
}); 

 $(".jtpl-close3").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-accent-treatment-popup3').hide();
});




$(".jtpl-accent-treatment4").click(function() {
        $(".jtpl_overlay").addClass('jtpl-shapepopup');
        $("body").addClass('jtpl-shapepopup1');
        $('.jtpl-accent-treatment-popup4').show();


        var positionsStepped600 = document.getElementById('modal_cut_slider-gemtreat400');

        var treatgemit5005 = document.getElementById('treatgem_active_text4').getAttribute('value');
        var treatgemit15005 = document.getElementById(treatgemit5005).getAttribute('value');
        var range_start_gemtreat5005 = document.getElementById('treatgem_active_slider4').getAttribute('value');

        var values = positionsStepped600.noUiSlider.get();
        var handle = range_start_gemtreat5005;
     
        if (range_start_gemtreat5005 == 0) {
            $(".noUi-origin").css("transform", "translate(-100%, 0px)");
            $(".tooltip-arrow-1").removeClass("hidden");
            $(".tooltip-arrow-2").addClass("hidden");

        }

        if (range_start_gemtreat5005 == 100) {
            $(".noUi-origin").css("transform", "translate(-0%, 0px)");
            $(".tooltip-arrow-2").removeClass("hidden");
            $(".tooltip-arrow-1").addClass("hidden");
        }
        $('.tooltip-inner-newtreat p').text(treatgemit15005);
    });

 

    $(document).on('click', '.jtpl-shapepopup', function(event) {
        $(".jtpl-accent-treatment-popup1").hide();
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
    });


 
 var treatgemtext1='',treatgemtext2='';
if(document.getElementById('treattext1')!= null){
 treatgemtext1 = document.getElementById('treattext1').getAttribute('value');
}
if(document.getElementById('treattext2') != null){
treatgemtext2 = document.getElementById('treattext2').getAttribute('value'); 
}
var positionsSteppedgemehhh = document.getElementById('modal_cut_slider-gemtreat400');

$('#treatgemtextclick4-1').click(function() {

 var values = positionsSteppedgemehhh.noUiSlider.get();
  var handle = 0;
$(".noUi-origin").css("transform", "translate(-100%, 0px)");  
$('.tooltip-inner-newtreat p').text(treatgemtext1);
   $(".tooltip-arrow-1").removeClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");  
 
});

$('#treatgemtextclick4-2').click(function() {
var values = positionsSteppedgemehhh.noUiSlider.get();
var handle = 100;
$(".noUi-origin").css("transform", "translate(-0%, 0px)");   
$('.tooltip-inner-newtreat p').text(treatgemtext2);
   $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");

});
if(document.getElementById('ehgem_active_slider') != null){
var range_start_gemeh = document.getElementById('ehgem_active_slider').getAttribute('value'); 
    
noUiSlider.create(positionsSteppedgemehhh, {
    start: range_start_gemeh,
    snap: true,
    connect: true,
   range: {
        'min': 0,
        'max': 100,
       
    }
});

positionsSteppedgemehhh.noUiSlider.on('change', function (values, handle) { 
if(values[handle] == 0){
  $('.tooltip-inner-newtreat p').text(treatgemtext1);
    $(".tooltip-arrow-1").removeClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");

}
  
if(values[handle] == 100){
  $('.tooltip-inner-newtreat p').text(treatgemtext2);
    $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");

}

});
}
$('#accent_treat_close4').click(function() {

var positionsStepped5600 = document.getElementById('modal_cut_slider-gemtreat400');

var treatgemit = document.getElementById('treatgem_active_text').getAttribute('value');
var treatgemit1 = document.getElementById(treatgemit).getAttribute('value');     
var range_start_gemtreat5555= document.getElementById('treatgem_active_slider').getAttribute('value'); 
  
var values = positionsStepped5600.noUiSlider.get();  
var handle = range_start_gemtreat5555;

if(range_start_gemtreat5555 == 0){
 $(".noUi-origin").css("transform", "translate(-100%, 0px)");    
    $(".tooltip-arrow-1").removeClass("hidden");
    $(".tooltip-arrow-2").addClass("hidden");

}
  
if(range_start_gemtreat5555 == 100){
  $(".noUi-origin").css("transform", "translate(-0%, 0px)"); 
   $(".tooltip-arrow-2").removeClass("hidden");
    $(".tooltip-arrow-1").addClass("hidden");
}

$('.tooltip-inner-newtreat p').text(treatgemit1);

  
}); 

 $(".jtpl-close4").click(function() {
        $(".jtpl_overlay").removeClass('jtpl-shapepopup');
        $("body").removeClass('jtpl-shapepopup1');
        $('.jtpl-accent-treatment-popup4').hide();
});
  
  
});
});